module.exports = __webpack_public_path__ + "static/media/365.7f7d4c0f.svg";